export default "__VITE_ASSET__ca917741__"